import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import QRCode from 'qrcode.react';
import stylesPay from './ButtonPayOrder.module.less';

import config from './config';
import { CONTEXT } from '../../config/index';
import { logging } from '../../actions/log';
import { getPayGamePayList } from '../../actions/native';
import { setOrderInfo, setAntiInfo, setPayPaySuc, setPayCheckIdSuc } from '../../actions/buttonpay';
import { formatMoney } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectButtonPay = createSelector(
  state => state.buttonpay,
  buttonpay => buttonpay,
);

let SoftPayTimeIndex = 0;
export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const { btnPayOrder } = useSelector(selectButtonPay);

  const [payResult, setPayResult] = useState(null);

  useEffect(() => {
    loggingOrder('P', 'PayGame_Order');
  }, []);

  const loggingOrder = useCallback(
    (category, action) => {
      dispatch(
        logging({
          category: category || 'C',
          action: action || 'PayGame_Order',
          label: '',
          param2: {
            source: btnPayOrder?.logInfo?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            softid: btnPayOrder?.soft?.softID,
            softName: btnPayOrder?.soft?.softName,
            softType: '0',
          },
          param3: btnPayOrder?.soft?.bizInfo || null,
        }),
      );
    },
    [btnPayOrder, logInfoData],
  );

  // 定时查询是否支付成功
  useEffect(() => {
    clearTimeout(SoftPayTimeIndex);
    SoftPayTimeIndex = setTimeout(() => {
      if (
        payResult &&
        btnPayOrder &&
        btnPayOrder?.orderInfo &&
        payResult?.orderId === btnPayOrder?.orderInfo?.orderId &&
        payResult?.payStatus === 1
      ) {
        dispatch(getPayGamePayList());
        clearTimeout(SoftPayTimeIndex);
      } else {
        orderPayResult();
      }
    }, 2000);
  }, [btnPayOrder, payResult]);

  const orderPayResult = useCallback(async () => {
    let res = await config.orderPayResult({
      orderId: btnPayOrder?.orderInfo?.orderId,
      queryUrl: btnPayOrder?.orderInfo?.queryUrl,
    });

    if (res && res?.status === 0 && res?.data && res?.data?.payStatus === 1) {
      dispatch(setPayPaySuc({ soft: btnPayOrder?.soft, result: res?.data }));
      loggingOrder('R', 'PayGame_Order_Pay_Success');
      setPayResult({ ...res?.data, payStatus: 1, time: res.time });
    }
    setPayResult({ ...res?.data, time: res.time });
  }, [btnPayOrder, logInfoData]);

  // 关闭弹框的时候清空redux中的数据
  const handleClearData = useCallback(() => {
    setTimeout(() => {
      dispatch(setOrderInfo({}));
      dispatch(setAntiInfo({}));
      dispatch(setPayPaySuc({}));
      dispatch(setPayCheckIdSuc({}));
    }, 100);
  }, []);

  const handleShowOrderList = useCallback(
    e => {
      loggingOrder('C', 'PayGame_Order_OrderList');

      history.push(`${CONTEXT}/ordercenter/gameorders?updatePage=1`);
      handleClearData();
    },
    [history, btnPayOrder, logInfoData],
  );
  const handleDialogClose = useCallback(
    flag => {
      loggingOrder('C', flag ? 'PayGame_Order_Cancel' : 'PayGame_Order_Close');
      handleClearData();
    },
    [btnPayOrder, logInfoData],
  );

  return (
    <div className={stylesPay.dialog_box}>
      <div className={stylesPay.dialog_order}>
        <div className="order_header">
          <div className="order_header_text">{`支付订单：${btnPayOrder?.soft?.softName}`}</div>
          <div
            className="order_header_close iconfont icon-opt_close"
            onClick={handleDialogClose}
          ></div>
        </div>
        {btnPayOrder &&
          btnPayOrder?.orderInfo &&
          btnPayOrder?.orderInfo?.orderId &&
          (!payResult || (payResult && payResult?.payStatus === 0)) && (
            <div className="order_cont">
              <div className="order_left">
                <div className="order_left_text1">订单信息：</div>
                <div className="order_left_text2">商品：{btnPayOrder?.soft?.softName}</div>
                <div className="order_left_text3">
                  <span className="order_left_currentPrice">
                    {`价格：${formatMoney(
                      parseFloat(btnPayOrder?.orderInfo?.productActualPrice || 0) / 100,
                    )}元`}
                  </span>
                  {btnPayOrder?.orderInfo?.productOriginalPrice &&
                    btnPayOrder?.orderInfo?.productOriginalPrice !==
                      btnPayOrder?.orderInfo?.productActualPrice && (
                      <span className="order_left_originalPrice">
                        {`${formatMoney(
                          parseFloat(btnPayOrder?.orderInfo?.productOriginalPrice || 0) / 100,
                        )}元`}
                      </span>
                    )}
                </div>

                {btnPayOrder?.orderInfo?.allowRefundFlag === 0 && (
                  <>
                    <div className="order_left_7day">
                      <span className="order_left_7day_icon"></span>
                      <span className="order_left_7day_text">
                        {`${btnPayOrder?.orderInfo?.allowRefundDay}天无理由退款`}
                      </span>
                    </div>
                    {/* <div className="order_left_7day_desc">
                      满足{btnPayOrder?.orderInfo?.allowRefundDay}
                      天无理由退款的前提下，可在联想应用商店，我的订单处申请退款，也可联系联想软件商店客服申请退款
                    </div>
                    <div className="order_left_text_desc1">
                      购买即代表您已阅读并接受<span>《法律信息》</span>
                    </div> */}
                  </>
                )}
              </div>
              <div className="order_right">
                <div className="order_right_qrcode">
                  <QRCode
                    className={stylesPay.qrcode_image}
                    size={130}
                    level="Q"
                    value={btnPayOrder?.orderInfo?.payUrl}
                  />
                </div>
                <div className="order_right_price">
                  ￥
                  <span>
                    {formatMoney((btnPayOrder?.orderInfo?.productActualPrice || 0) / 100)}
                  </span>
                </div>
                <div className="order_right_desc">
                  <span className="order_right_wx"></span>微信
                  <span className="order_right_zfb"></span>支付宝扫码支付
                </div>
              </div>
            </div>
          )}
        {btnPayOrder?.orderInfo &&
          btnPayOrder?.orderInfo?.orderId &&
          payResult &&
          payResult?.payStatus === 1 && (
            <div className={'order_other'}>
              <div className={'other_logo_success'}></div>
              <div className={'other_info'}>支付成功</div>
              <div className={'other_text'}>支付订单：{btnPayOrder?.soft?.softName}</div>
              <div className={'other_text'}>您也可以在订单中心查看订单充值状态</div>
              <div className={'btn_sure'} onClick={handleShowOrderList}>
                查看订单
              </div>
            </div>
          )}
        {/* {btnPayOrder && btnPayOrder?.orderInfo && btnPayOrder?.orderPayResult === 'payFail' && (
          <div className={'order_other'}>
            <div className={'other_logo_fail'}></div>
            <div className={'other_info'}>支付失败</div>
            <div className={'other_text'}>支付订单：{btnPayOrder?.soft?.softName}</div>
            <div
              className={'btn_cancel'}
              onClick={() => {
                handleDialogClose(true);
              }}
            >
              取消
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
});
